import React from "react";
import styles from "./../../../ricos-common-plugins/gap-spacer/gap-spacer-component/gap-spacer-styles-scss.js";
const GapSpacer = () => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.gapSpacerViewer });
};
export {
  GapSpacer
};
//# sourceMappingURL=gap-spacer.js.map
